// extracted by mini-css-extract-plugin
export default {"creditAccount":"customerDetail_creditAccount__NcVB6"};